import { useEffect, useRef } from 'react';

export const useOutsideAlerter = (ref, callbackOutside) => {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callbackOutside;
    }, [callbackOutside]);

    useEffect(() => {
        const handleClickOutside = event => {
            if (ref.current && !ref.current.contains(event.target)) {
                savedCallback.current();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
};
